var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasPhotoAttachment(_vm.blockoutDay)
    ? _c(
        "ul",
        { staticClass: "attachment-list" },
        _vm._l(_vm.getPhotoUrls(_vm.blockoutDay.attachments), function (value) {
          return _c("li", { key: value.photoUrl }, [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.viewPhoto(
                      _vm.blockoutDay.attachments.photoUrls,
                      value
                    )
                  },
                },
              },
              [
                _c("md-icon", [
                  _vm._v("\n                image\n            "),
                ]),
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(value.photoName) +
                      "\n            "
                  ),
                ]),
              ],
              1
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }